<template>
    <div class="page">
        <div>
            <ion-grid>
                <ion-row>
                    <ion-col size="3.5" class="l-c1" size-lg="3.5" size-xl="3.5" size-md="3.5" size-sm="12" size-xs="12">
                        <ion-label v-if="!displayLineChart1" style="font-weight: bold;">Customer Visits</ion-label>
                        <ion-button class="btn-refresh" v-if="!displayLineChart1" @click="LoadCustomerVisitCount()">
                            <ion-icon :icon="refresh"></ion-icon>
                        </ion-button>
                        <div v-if="displayLineChart1">
                            <p class="display-value" v-if="customerVisitCountData.displayChart == true">{{"Customer Visits : " + customerVisitCountData.count }}</p>
                            <canvas id="lineChart1"></canvas>
                            <p class="noStations"  style="text-align: center;" v-if="customerVisitCountData.displayChart == false">Customer Visits: No data to display</p>
                        </div>
                    </ion-col>
                    <ion-col size="0.3" size-sm="0.3" size-lg="0.3"  size-md="0.3" size-xs="0.3"></ion-col>
                    <ion-col size="3.5" size-sm="12" size-lg="3.5"  size-md="3.5" class="l-c2" size-xs="12">
                        <ion-label v-if="!displayLineChart2" style="font-weight: bold;">Revenue</ion-label>
                        <ion-button class="btn-refresh" v-if="!displayLineChart2" @click="loadTransactionCount()">
                        <ion-icon :icon="refresh"></ion-icon>
                        </ion-button>
                        <div v-if="displayLineChart2">
                        <p class="display-value" v-if="transactionCountData.displayChart == true">{{"Revenue : $" + transactionCountData.count * 2 }}</p>
                        <canvas id="lineChart2"></canvas>
                        <p class="noStations"  style="text-align: center;" v-if="transactionCountData.displayChart == false">Revenue: No data to display</p>
                        </div>
                    </ion-col>
                    <ion-col size="0.3" size-md="0.3" size-lg="0.3"  size-sm="0.3" size-xs="0.3"></ion-col>
                    <ion-col size="3.5" size-md="3.5" size-lg="3.5"  size-sm="12" class="l-c3" size-xs="12">
                        <ion-label v-if="!displayLineChart3" style="font-weight: bold;">Session Counts</ion-label>
                        <ion-button class="btn-refresh" v-if="!displayLineChart3" @click="loadRevenueCount()">
                        <ion-icon :icon="refresh"></ion-icon>
                        </ion-button>
                        <div v-if="displayLineChart3">
                        <p class="display-value" v-if="revenueCountData.displayChart == true">{{"Session Counts : " + revenueCountData.count }}</p>
                        <canvas id="lineChart3"></canvas>
                        <p class="noStations"  style="text-align: center;" v-if="revenueCountData.displayChart == false">Session Counts: No data to display</p>
                        </div>
                    </ion-col>
                </ion-row>
                <ion-row class="chart-label rectangle-dump1" v-if="displayFenfeoAdminChart">
                    <ion-col size-sm="12"  size-lg="12" size-md="12" size-xs="12">
                        <h6 style="color: green; font-weight: bold;">{{'Energy Consumed(KWH) : '+ greenHousGasData.consumedKWH + ", "+ "Kg CO2e : " + greenHousGasData.co2index}}</h6>
                    </ion-col>
                </ion-row>
                <ion-row class="rectangle-dump1 dashboard-screen">
                    <ion-col size="2" size-md="2" size-lg="2"  size-sm="2" size-xs="0.5"></ion-col>
                    <ion-col size="8" size-md="8" size-lg="8"  size-sm="8" size-xs="11">
                        <canvas id="barChart1" class="barChart1"></canvas>
                    </ion-col>
                    <ion-col size="2" size-md="2" size-lg="2"  size-sm="2" size-xs="0.5"></ion-col>
                </ion-row>
            </ion-grid>
        </div>
    </div>
</template>

<script>
import { defineComponent, render } from "vue";
import { refresh } from 'ionicons/icons';
import Chart from "chart.js/auto";
import { CorporateService } from "../../service/corporate/corporate.service";
import { flash } from 'ionicons/icons';
import { IonButton, IonRow, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { ToastUtils } from "../../util/toast-utils";
import userData from "../../../public/assets/data/data.json";

export default defineComponent ({
    name: 'energyConsumedDashboard',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonInput, IonButton, IonIcon, IonSpinner
    },
    props: {
        consumeEnergyData : {type: Object}
    },
    data() {
        return {
            refresh,
            chartTypes: [{'name' : 'Charger Status'},{"name" : "Admin Dashboard"}],
            chartName: "",
            branchId: "",
            chartTypeInd: true,
            doughnutChartInd: true,
            myChart1: null,
            chargerStatusData: "",
            displayInd: false,
            loaderTab: false,
            noStationAssociatedInd: true,
            displayLineChart1: false,
            displayLineChart2: false,
            displayLineChart3: false,
            displayLineChart4: false,
            displayChargerStatus: false,
            displayFenfeoAdminChart: false,
            chargerCurrentStatusChart: null,
            dailyUsageBarChart: null,
            greenHousGasData: null,
            customerVisitCountData: null,
            transactionCountData: null,
            revenueCountData: null
        }
    },
    async mounted() {
      this.displayFenfeoAdminChart = true
      this.greenHousGasData = this.consumeEnergyData;
        this.drawBarChart(this.greenHousGasData);
    },
    methods: {
        async greenHousGasChart(greenHousGasData) {
        try {
            var ctx = document.getElementById('barChart1');
            if(greenHousGasData.displayChart == false) {
                ctx = null;
            } else {
            var data = {
                labels: greenHousGasData.label,
                datasets: [{
                    label: 'Energy Consumed(KWH) :'+ greenHousGasData.consumedKWH + "     "+ "Kg CO2e :" + greenHousGasData.co2index,
                    // fillColor: "#79D1CF",
                    // strokeColor: "#79D1CF",
                    fontSize: 30,
                    data: greenHousGasData.data,
                    fill: true,
                    backgroundColor: 'green',
                    barPercentage: 10,
                    barThickness: 10,
                    maxBarThickness: 10,
                    minBarLength: 1
                }]
            }
            this.dailyUsageBarChart = new Chart(ctx, {
                type: 'bar',
                data: data,
                options : {
                    legend: {
                        display: false
                    },
                    "animation": {
                        "hover": {
                            "animationDuration": 2
                        },
                        "duration": 1,
                        "onComplete": function() {
                            var chartInstance = this.chart,
                            ctx = chartInstance.ctx;
                            ctx.font = Chart.helpers.fontString("17", Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'bottom';
                            this.data.datasets.forEach(function(dataset, i) {
                                var meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach(function(bar, index) {
                                    var data = dataset.data[index];
                                    ctx.fillText(data, bar._model.x, bar._model.y - 5);
                                });
                            });
                        }
                    },
                    tooltips: {
                        enabled: false
                    },
                    elements: {
                        point:{
                            radius: 0
                        }
                    },
                    scales: {
                        xAxes: [{
                            position:'top',
                            barPercentage: 10,
                            barThickness: 60,
                            maxBarThickness: 25,
                            gridLines: {
                                display:true
                            },
                            ticks: {
                                display: true,
                                fontSize:17,
                                fontColor: "red"
                            }
                        }],
                        yAxes: [
                            {
                                display: false,
                                gridLines: {
                                    display: true
                                },
                                ticks: {
                                    max: Math.max(...data.datasets[0].data) + 10,
                                    display: false,
                                    beginAtZero: true
                                }
                            }],
                        }
                    }
                });
        }

        } catch(error) {
            // new ToastUtils().presentToast(error.response.data.errors[0].detail);
            alert(error)
        }
        },
        
        async LoadCustomerVisitCount() {
        
        this.customerVisitCountData = await userData.dashboard.customerVisit;
        if(this.customerVisitCountData) {
            this.displayLineChart1 = true;
            setTimeout(() => {
            this.customerVisitCountChart(this.customerVisitCountData);
            }, 500)
        }
        
        },

        async loadTransactionCount() {    
        this.transactionCountData = await userData.dashboard.transactionCount;
        if(this.transactionCountData) {
            this.displayLineChart2 = true;
            setTimeout(() => {
            this.transactionCountChart(this.transactionCountData);
            }, 500)
        }
        },
        async loadRevenueCount() {      
        this.revenueCountData = await userData.dashboard.transactionCount;
        if(this.revenueCountData) {
            this.displayLineChart3 = true;
            setTimeout(() => {
            this.revenueCountChart(this.revenueCountData);
            }, 500)
        }
        },
        async revenueCountChart(revenueData) {
        try {
            var ctx = document.getElementById('lineChart3');
            if(revenueData.displayChart == false) {
            ctx = null;
            } else {
            var myChart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: revenueData.label,
                datasets: [{
                label: 'Revenue (INR) ' +"\n"+ revenueData.count,
                data: revenueData.data,
                fill: true,
                borderColor: 'rgb(10, 192, 10)',
                tension: 0.3,
                backgroundColor: 'rgba(10, 85, 10, 0.4)',
                }]
            },
            options : {
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                animations: {
                    tension: {
                        duration: 1000,
                        easing: 'linear',
                        from: 1,
                        to: 0,
                        loop: true
                    }
                },
                // legend: {
                // display: false
                // },
                // tooltips: {
                // enabled: false
                // },
                elements: {
                point:{
                    radius: 0
                }
                },
                scales: {
                xAxes: [{
                    gridLines: {
                        display:false
                    },
                    ticks: {
                    display: false
                    }
                }],
                yAxes: [{
                    gridLines: {
                        display:false
                    },
                    ticks: {
                    display: false
                    }  
                }]
                }
            }
            });
        }
        } catch(er) {
            alert(er)
        }
        
        },
        async customerVisitCountChart(chartData) {
        try {
            var ctx = document.getElementById('lineChart1');
            if(chartData.displayChart == false) {
                ctx = null;
            } else {
                var myChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: chartData.label,
                    datasets: [{
                        label: 'Customer Visits' +"\n"+ chartData.count,
                        data: chartData.data,
                        fill: true,
                        borderColor: 'rgb(150, 120, 150)',
                        tension: 0.1,
                        backgroundColor: 'rgba(251, 85, 85, 0.4)',
                    }]
                },
                options : {
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            enabled: false
                        }
                    },
                    // responsive: true,
                    animations: {
                        tension: {
                            duration: 1000,
                            easing: 'linear',
                            from: 1,
                            to: 0,
                            loop: true
                        }
                    },
                    maintainAspectRatio: true,
                    // legend: {
                    //     display: false
                    // },
                    // tooltips: {
                    //     enabled: false
                    // },
                    elements: {
                        point:{
                            radius: 0
                        }
                    },
                    scales: {
                        // xAxes: [{
                        //     gridLines: {
                        //         display:false
                        //     },
                        //     ticks: {
                        //     display: false
                        //     }
                        // }],
                        // x: {
                        //     display: false
                        // },
                        // y: {
                        //     display: false,
                        //     grid: {
                        //         display: true

                        //     }
                        // },
                        // yAxes: [{
                        //     gridLines: {
                        //         display:false
                        //     },
                        //     ticks: {
                        //     display: false
                        //     }  
                        // }]
                    }
                }
            });
        }
        } catch(er) {
            alert(er)
        }
        },
        async transactionCountChart(transactionData) {
        try {
            var ctx = document.getElementById('lineChart2');
            if(transactionData.displayChart == false) {
            ctx = null;
            } else {
            var myChart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: transactionData.label,
                datasets: [{
                label: 'Transaction Counts' +"\n"+ transactionData.count,
                data: transactionData.data,
                fill: true,
                borderColor: 'rgb(192, 40, 192)',
                tension: 0.3,
                backgroundColor: 'rgba(10, 85, 100, 0.4)',
                }]
            },
            options : {
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    }
                },
                animations: {
                    tension: {
                        duration: 1000,
                        easing: 'linear',
                        from: 1,
                        to: 0,
                        loop: true
                    }
                },
                // legend: {
                // display: false
                // },
                // tooltips: {
                // enabled: false
                // },
                elements: {
                point:{
                    radius: 0
                }
                },
                scales: {
                xAxes: [{
                    gridLines: {
                        display:false
                    },
                    ticks: {
                    display: false
                    }
                }],
                yAxes: [{
                    gridLines: {
                        display:false
                    },
                    ticks: {
                    display: false
                    }  
                }]
                }
            }
            });
        }
        } catch(er) {
            alert(er)
        }
        },
        drawBarChart(greenHousGasData) {
            var ctx = document.getElementById('barChart1');
            const labels = greenHousGasData.label;
            const data = {
                labels: labels,
                datasets: [{
                    label: 'Energy Consumed(KWH) :'+ greenHousGasData.consumedKWH + "     "+ "Kg CO2e :" + greenHousGasData.co2index,
                    data: greenHousGasData.data,
                    borderWidth: 1,
                    backgroundColor: 'green',
                    barPercentage: 1,
                }]
            };
            this.dailyUsageBarChart = new Chart(ctx, {
                type: 'bar',
                data: data,
                options: {
                    animation: {
                        duration: 1,
                        "onComplete": function() {
                            var chartInstance = new Chart
                            // ctx = chartInstance.ctx;
                            var cxt = chartInstance.ctx;

                            this.data.datasets.forEach(function(dataset, i){
                                var meta = chartInstance.getDatasetMeta(i);
                                meta.data.forEach(function(bar, index) {
                                    var data = dataset.data[index];
                                    cxt.fillText(data, bar.x, bar.y - 5)
                                })
                            })   
                        }
                    },
                    responsive: true,
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            enabled: false
                        }
                    },
                    scales: {
                       y: {
                            display: false
                       },
                       x: {
                            grid: {
                                display: true
                            },
                            ticks: {
                                display: true,
                                font: {
                                    size: 12
                                },
                                color: Chart.defaults.color = "red"
                            },
                            border: {
                                display: true,
                                color: Chart.defaults.color = "green"
                            }
                       }
                    }                
                },
            })
        }
    },
    
})
</script>

<style scoped>
/* .dashboard-screen {
    overflow: scroll !important;
} */
.available {
  color: green;
}
.unavailable {
  color: red;
}
.charging {
  color: orange;
}
.thirdparty {
  color: #26285a;
}
.total {
  color: rgb(159, 21, 223);
}
.status-info {
  padding: 15px;
  margin-top: 35px;
  margin-right: 35px;
  /* text-align: center; */
  border: 3px solid grey;
  border-radius: 10px;
  box-shadow: 3px 3px grey;
}
.noStations {
  margin-top: -140px;
  font-weight: bold;
}
.noStations1 {
  margin-top: -220px;
  font-weight: bold;
}
.noAssociatedStations {
    
  /* margin-top: -440px; */
  font-weight: bold;
}
.l-c1, .l-c2, .l-c3, .l-c4 {
  border: 1px solid lightgrey;
  margin: 2px;
  background: #ebebeb;
}
.btn-refresh {
  text-align: center !important;
  margin-left: 40px;
    font-family: "Roboto";
    font-size: 1.5rem;
    letter-spacing: 0;
    color: #ffffff;
    height: 40px;
    --background: #e1899c 0% 0% no-repeat padding-box;
    --background-focused: #b4b2b2 !important;
    --background-hover: #b4b2b2 !important;
    --webkit-background-focused: #b4b2b2 !important;
    --webkit-background-hover: #b4b2b2 !important;
    border-radius: 3px;
    opacity: 1;
    /* bottom: 0; */

}
.barChart1 {
    height: 370px !important;
    /* overflow: scroll */
}
.chart-label {
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
}
.my-chart {
    width: 450px !important;
    height: 450px !important;
}
.rectangle-dump {
  
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  padding: 1px;
  opacity: 1;
}
.rectangle-dump1 {
  
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  padding: 1px;
  opacity: 1;
}
.display-value {
  text-align: left;
  padding: 0;
  margin: 0;
  font-weight: bold;
}
@media screen and (max-width: 360px) {
    .my-chart {
        width: 350px !important;
        height: 350px !important;
    }
    
    .barChart1 {
        height: 290px !important;
        /* overflow: scroll */
    }
    .status-info {
        padding: 15px;
        margin-top: 35px;
        margin-right: 3px;
        text-align: center;
    }
}
</style>